// Monitored feature codes — direct port of Angular my-plan-feature-codes.ts.
// Product team can review/extend this list without touching any component.
export const MONITORED_FEATURE_CODES = [
  'ALTLOANXPN',
  'BAMA',
  'EFXCM',
  'EFXCMT',
  'NCOA',
  'EFXVS',
  'EXPAA',
  'LNAA',
  'EXPSIM',
  'FINCALC',
  'FOURIQ',
  'FTM',
  'HTMON',
  'PRP',
  'PRM',
  'INSURANCE',
  'PRS',
  'PRC',
  'SECURITY_FREEZE',
  'PRI',
  'SOCIAL_MONITOR',
  'SPENDING_TRACKER',
  'TUCM',
  'TUCMT',
  'TUNIQ',
  'TUNIQB',
  'TUCMB',
  'WALLET_PROTECTION',
  'XPNCL',
  'EXPCMB',
  'EXPCM',
  'NEWS_ARTICLES',
  'PASSWORD_MANAGER_SP',
  'EXPRTA',
  'EXPDA',
  'EXPPA',
  'EXPCA',
] as const;

export type MonitoredFeatureCode = (typeof MONITORED_FEATURE_CODES)[number];
